import { REPORT } from '../types'

const initialState = {
  reportLoading: false,
}

export default function reportReducer(state = initialState, action) {
  switch (action.type) {
    case REPORT.LOADING_START:
      return { ...state, reportLoading: true }
    case REPORT.LOADING_END:
      return { ...state, reportLoading: false }
    default:
      return state
  }
}
